import React from 'react';
import styled, { css } from 'styled-components';
import { lightGrey2Color, lightGrey1Color } from 'js/config/style';
import { Link } from '@reach/router';

const baseStyle = css`
  display: block;
  font-size: 0.8rem;
  padding: 0.5rem;
  color: black;
  border-top: 1px solid ${lightGrey2Color};

  &:first-child {
    border-top: none;
  }
`;

const ListDisplay = styled.div`
  ${baseStyle}
`;

const ListLink = styled(Link)`
  ${baseStyle}

  &:hover {
    color: black;
    text-decoration: none;
    background: ${lightGrey1Color};
  }

  &:active {
    color: black;
    background: ${lightGrey1Color.darken(0.5)};
  }

  &:last-child {
    border-radius: 0 0 0.25rem 0.25rem;
  }
`;

export default props => (props.to ? <ListLink {...props} /> : <ListDisplay {...props} />);
